import React, { Component } from "react";
import { Spinner } from "@blueprintjs/core";
import PlayersSidebar from "../echipa/PlayersSidebar";
import Field from "../echipa/Field";

export default class TrainingInfoPlayers extends Component {
    state = {
        sidebarOpen: true,
        collapsed: {
            active: true,
            injured: true,
            absent: true,
            excused: true,
            unselected: true,
        },
        formation: "4-3-3"
    };

    toggleSidebar = () => this.setState(prev => ({ sidebarOpen: !prev.sidebarOpen }));

    toggleSection = key =>
        this.setState(prev => ({
            collapsed: { ...prev.collapsed, [key]: !prev.collapsed[key] }
        }));

    render() {
        const { players, onStatusChange } = this.props;
        const { sidebarOpen, collapsed, formation } = this.state;

        if (!players) return <Spinner />;
        console.log('TrainingInfoPlayers --------------', this.props)
        return (
            <div className={`training-page field-container ${sidebarOpen ? "sidebar-open" : "sidebar-closed"}`}>
                <PlayersSidebar
                    players={players}
                    sidebarOpen={sidebarOpen}
                    collapsed={collapsed}
                    onToggleColl={this.toggleSection}
                    onChangeStatus={onStatusChange}
                    training={this.props.training}
                />

                <div className="training-players-col">
                    <Field players={players.filter(p => p.status === 'active' || !p.status)} formation={formation} />
                </div>
            </div>
        );
    }
}
